import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Unstable_Grid2";
import { formatCurrency } from "tools/stringUtils";
import type { SubBasket } from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import type { DropShipConfig } from "_redux/reducers";
import PriceRow from "./PriceRow";

type Props = { dropShipConfig?: DropShipConfig } & Omit<
  SubBasket,
  "orderitems"
>;

const CartSubBasketPriceSummary: FC<Props> = ({
  articleType,
  dropShipConfig,
  total,
  totalAdjustment,
  totalProduct,
  totalShipping,
}) => {
  const { t } = useTranslation();
  const sumLabel = `${t("cart.sum")} ${
    dropShipConfig?.title?.trim() ||
    t(`cart.articleType.${articleType.toLowerCase()}`)
  }`;

  return (
    <Grid container>
      <PriceRow
        label={t("cart.subtotal")}
        labelVariant="body2"
        valueVariant="body2"
        value={formatCurrency(totalProduct)}
      />
      {totalAdjustment !== 0 && (
        <PriceRow
          label={t("cart.promotionCode")}
          labelVariant="body2"
          valueVariant="body2"
          value={formatCurrency(totalAdjustment)}
        />
      )}

      <PriceRow
        label={t("cart.shippingCosts")}
        labelVariant="body2"
        valueVariant="body2"
        value={formatCurrency(totalShipping)}
      />

      <PriceRow
        label={sumLabel}
        value={formatCurrency(total)}
        labelVariant="body2"
        valueVariant="body2"
        labelMarginRight={1}
        bold
      />
    </Grid>
  );
};

export default React.memo(CartSubBasketPriceSummary);
